import _toConsumableArray from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import { constantRoutes } from '@/router';
import { getRouters } from '@/api/menu';
import Layout from '@/layout/index';
import LayoutChildren from '@/layout/children';
var permission = {
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    topbarRouters: [],
    defaultRoutes: [],
    allRoutes: [],
    changeHosindex: '1',
    navbarIndex: null,
    defaultProject: null
  },
  mutations: {
    SET_ROUTES: function SET_ROUTES(state, routes) {
      state.addRoutes = routes;
      state.routes = constantRoutes.concat(routes);
    },
    SET_DEFAULT_ROUTES: function SET_DEFAULT_ROUTES(state, routes) {
      state.defaultRoutes = constantRoutes.concat(routes);
    },
    SET_SIDEBAR_ROUTERS: function SET_SIDEBAR_ROUTERS(state, routes) {
      state.sidebarRouters = routes;
    },
    SET_TOPBAR_ROUTES: function SET_TOPBAR_ROUTES(state, routes) {
      // 顶部导航菜单默认添加统计报表栏指向首页
      var index = [{
        path: 'index',
        meta: {
          title: '统计报表',
          icon: 'dashboard'
        }
      }];
      state.topbarRouters = routes.concat(index);
    },
    SET_ALL_ROUTERS: function SET_ALL_ROUTERS(state, routes) {
      state.allRoutes = routes;
    },
    SET_NAVBAR_INDEX: function SET_NAVBAR_INDEX(state, index) {
      state.navbarIndex = index;
    },
    SET_DEFAULIT_PROJECT: function SET_DEFAULIT_PROJECT(state, data) {
      state.defaultProject = data;
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes: function GenerateRoutes(_ref) {
      var commit = _ref.commit;
      return new Promise(function (resolve) {
        // 向后端请求路由数据
        getRouters().then(function (res) {
          var _dataCollection$, _dataCollection$$ProA;
          // console.log('res',res)
          var resData = res.data;
          commit('SET_ALL_ROUTERS', resData);
          //为数据采集时 设置默认项目
          var dataCollection = resData.filter(function (v) {
            return v.id == 3;
          });
          if (dataCollection.length) commit('SET_DEFAULIT_PROJECT', (_dataCollection$ = dataCollection[0]) === null || _dataCollection$ === void 0 ? void 0 : (_dataCollection$$ProA = _dataCollection$.ProAuthMsg) === null || _dataCollection$$ProA === void 0 ? void 0 : _dataCollection$$ProA.ProAuthInfo);
          var accessedRoutes = [];
          resData.forEach(function (v, i) {
            accessedRoutes.push.apply(accessedRoutes, _toConsumableArray(filterAsyncRouter(v.UserMenusList)));
          });
          accessedRoutes.push({
            path: '*',
            redirect: '/404',
            hidden: true
          });
          commit('SET_ROUTES', accessedRoutes);
          commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(accessedRoutes));
          commit('SET_DEFAULT_ROUTES', accessedRoutes);
          commit('SET_TOPBAR_ROUTES', accessedRoutes);
          resolve(accessedRoutes);
        });
      });
    },
    GenerateRoutess: function GenerateRoutess(_ref2, payload) {
      var commit = _ref2.commit,
        state = _ref2.state;
      var datas = payload.key ? state.allRoutes.filter(function (v) {
        return v.id == payload.key;
      }) : [state.allRoutes[0]];
      var accessedRoutes = filterAsyncRouter(datas[0].UserMenusList);
      accessedRoutes.push({
        path: '*',
        redirect: '/404',
        hidden: true
      });
      commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(accessedRoutes));
    }
  }
};

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(function (route) {
    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'Layout') {
        if (route.pid === 0) {
          route.component = Layout;
        } else {
          route.component = LayoutChildren;
        }
      } else {
        route.component = loadView(route.component);
      }
    }
    if (route.children != null && route.children && route.children.length > 0) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });
}
export var loadView = function loadView(view) {
  // 路由懒加载
  return function (resolve) {
    return require(["@/views/".concat(view)], resolve);
  };
};
export default permission;